<template lang="html">
  <!-- <img src="@/assets/logo.png" alt="Diensten Centrum" width="200" /> -->
  <h1 class="title text-primary">Enter your work details</h1>
  <input
    v-model="company"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Company"
    required
  />
  <input
    v-model="jobposition"
    class="form-control field no-focusborder"
    type="text"
    ref="inputfield"
    placeholder="Job position"
    required
  />
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-secondary btn-lg"
      :disabled="isDisabled == true"
      @click="setWorkData()"
    >
      Continue
    </button>
  </div>
</template>

<script>
export default {
  name: "WorkDataScreen",
  data: () => ({
    company: null,
    jobposition: null,
  }),
  computed: {
    isDisabled() {
      if (this.company && this.jobposition) {
        return false;
      }
      return true;
    },
  },
  methods: {
    setWorkData() {
      this.$store.commit("setCompany", this.company);
      this.$store.commit("setJobposition", this.jobposition);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 30px;
  color: #000 !important;
}
.title {
  padding-bottom: 10px;
}
.field {
  /* text-transform: uppercase; */
  margin: auto;
  outline: none;
  border: none;
  width: 100%;
  padding: 10px;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 20px;
  color: #000;
  background-color: rgba(255, 255, 255, 0.8);
}
.field::placeholder {
  color: #555;
  opacity: 0.5;
}
</style>
